export default "__VITE_ASSET__RNNxFg5Y__"